<template>
	<div style="background-color:#fffcf7;" class="container">
		<headMenu />
		<div class="text-center">
			<img
				alt="شرکت فناوری  رهنمای دنیای آینده (فردا)"
				title="شرکت فناوری  رهنمای دنیای آینده (فردا)"
				:src="require('../../assets/img/Shape_Title.svg')"
			/>
			<p class="bMikhak text-center text-success" style="font-size: 24px;">
				مشارکت در آموزش
				<img
					alt="مشارکت در آموزش"
					title="مشارکت در آموزش"
					:src="require('../../assets/img/love.svg')"
					width="40"
				/>
			</p>
		</div>
		<participation_in_education v-if="!this.show" @show_page="(e)=>{ this.show = true; }" />
		<part1 v-else />
		<footerPage />
	</div>
</template>

	<script>
		import textInput from  "../../UI/input/textInput.vue";
		import headMenu from  "../../menu/headMenu.vue";
		import btn from  "../../UI/button/btn.vue";
		import back from  "../../UI/back/back.vue";
		import part1 from  "./part1.vue";
		import participation_in_education from  "./participation_in_education.vue";
		import part2 from  "../../USER/reserved_user_list/part2.vue";
		import footerPage from  "../../USER/public/home/home_part9.vue";

		export default {
			name: 'signupTeacher',
			data(){
				return {
					imgurl: window.imgurl,
					baseurl: window.baseurl,
					degrees: [],
					category: [],
					location: [],
					show: false,
				}
			},
			components: {
				btn,
				part1,
				part2,
				back,
				footerPage,
				headMenu,
				textInput,
				participation_in_education,
			},
			props: [],
			computed :{
			},
			mounted(){
		this.$swal.close();
			},
			methods:{
				// *********************************************************************
				chechRole(){
					let user = this.$localStorage.get('user');
					if(user == null){
						return true;
					}else if(user.username.role != 3){
						return true;
					}else{
						return false;
					}
				},
				// *********************************************************************
			}
		}
	</script>
<style>

</style>
